import { generateApiAction, RESPONSETYPE } from '../Generator'
import Types from '../Types'
import { printControl } from '../Api'

export default generateApiAction({
  baseType: Types.PRINT.CONTROL,
  api: printControl,
  responseType: RESPONSETYPE.FILE
})



// WEBPACK FOOTER //
// ./src/actions/print/PrintControlAction.js